var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Card',[_c('StrapiList',{attrs:{"source":"/campaigns","query":{ archived: false }},scopedSlots:_vm._u([{key:"default",fn:function(list){return [_c('CampaignsTable',_vm._b({},'CampaignsTable',list,false))]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }